import React from "react";
import { FooterWrapper, SocialMedia } from "./styled";
import { ReactComponent as DogeLogo } from "assets/logo/logotext.svg";
import { Flex } from "Element/Flex";

import { ReactComponent as InstagramIcon } from "assets/icons/instagram.svg";
import { ReactComponent as TwitterIcon } from "assets/icons/twitter.svg";
import { ReactComponent as DiscordIcon } from "assets/icons/discord.svg";

const Footer = () => {
  return (
    <FooterWrapper justifyContent="space-between" alignItems="center">
      <Flex flexDirection="column">
        <DogeLogo className="doge-logo" />
        <span className="company">© 2021 Boxyguild LLC.</span>
      </Flex>
      <Flex flexDirection="column" justifyContent="flex-end">
        <span className="follow">Follow US 👇</span>
        <Flex>
          <SocialMedia>
            <InstagramIcon />
          </SocialMedia>
          <SocialMedia>
            <DiscordIcon />
          </SocialMedia>
          <SocialMedia>
            <TwitterIcon />
          </SocialMedia>
        </Flex>
      </Flex>
    </FooterWrapper>
  );
};

export default Footer;
